import { createContext, useContext, useState, useCallback } from "react";
import { getProfile, saveProfile, createProfile as createP, logout as logoutStore, recordResult, joinGroup as joinG, awardOffer as awardO, toggleRedeem as toggleR } from "../lib/storage";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [profile, setProfile] = useState(() => getProfile());
  // quiz session carried between setup -> play -> results
  const [session, setSession] = useState(null);
  const [lastResult, setLastResult] = useState(null);

  const login = useCallback((handle, name) => {
    const p = createP(handle, name);
    setProfile(p);
    return p;
  }, []);

  const logout = useCallback(() => {
    logoutStore();
    setProfile(null);
    setSession(null);
    setLastResult(null);
  }, []);

  const finishQuiz = useCallback((meta) => {
    const { profile: updated, newlyEarned } = recordResult(getProfile(), meta);
    setProfile(updated);
    setLastResult({ ...meta, newlyEarned });
    return newlyEarned;
  }, []);

  const joinGroup = useCallback((groupName) => {
    const current = getProfile();
    if (!current) return [];
    const { profile: updated, newlyEarned } = joinG(current, groupName);
    setProfile(updated);
    return newlyEarned;
  }, []);

  const awardOffer = useCallback((offer) => {
    const current = getProfile();
    if (!current) return null;
    const { profile: updated, entry } = awardO(current, offer);
    setProfile(updated);
    return entry;
  }, []);

  const toggleRedeem = useCallback((code) => {
    const current = getProfile();
    if (!current) return;
    setProfile(toggleR(current, code));
  }, []);

  const value = {
    profile,
    setProfile: (p) => { saveProfile(p); setProfile(p); },
    login,
    logout,
    session,
    setSession,
    lastResult,
    finishQuiz,
    joinGroup,
    awardOffer,
    toggleRedeem,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
